/**
 * Case story template and URL paths by category.
 * WordPress has only two categories for case stories:
 * - Our work (FI), slug "tyomme" → case story template, Finnish → /tyomme/{post-slug}
 * - Our work (EN), slug "work"   → case story template, English → /en/work/{post-slug}
 * There is no separate "case story" or "case study" category.
 */

export const FINNISH_CATEGORY_SLUG = 'tyomme';
export const ENGLISH_CATEGORY_SLUG = 'work';

/**
 * Returns the case story URL path for a post based on its categories.
 * Use when linking to case stories (e.g. from front page or category archive).
 * Only Our work (FI) / Our work (EN) are considered.
 * @param {{ slug?: string, uri?: string, categories?: { nodes?: Array<{ slug: string }> } }} post - Post with slug/uri and categories
 * @returns {string|null} Path like /tyomme/mehilainen or /en/work/mehilainen, or null if not in tyomme/work
 */
export function getCaseStudyPath(post) {
  if (!post) return null;
  const slugs = post?.categories?.nodes?.map((c) => c.slug) ?? [];
  const slug =
    typeof post.slug === 'string'
      ? post.slug
      : (post.uri && String(post.uri).replace(/^\/+|\/+$/g, '').split('/').pop()) || '';
  if (!slug) return null;
  if (slugs.includes(FINNISH_CATEGORY_SLUG)) return `/tyomme/${slug}`;
  if (slugs.includes(ENGLISH_CATEGORY_SLUG)) return `/en/work/${slug}`;
  return null;
}

/**
 * Language from path: /en/... => 'en', else 'fi'
 */
export function getLangFromPath(path) {
  return path && String(path).startsWith('/en/') ? 'en' : 'fi';
}
